<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="caja-operacion" titulo="Factura" [dato]="dato"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>


<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; overflow-y:auto; overflow-x:hidden; display:block;" [style.height.px]="ctrl.tamano-75">

            <!-- formulario -->
            <a id="catalogos" (click)="ctrl.cargarCatalogo('catalogos_usos_cfdis', CFDI_PATH+'/api/v1/catalogo-uso-cfdi'); ctrl.cargarCatalogo('logos64', 'logos64', 'logo64');"></a>
            <a id="logo64" (click)="asignarLogos(ctrl.logos64); "></a>
            <section class="hero is-primary">
                <div class="hero-body">
                    <nav class="level">
                        <!-- Left side -->
                        <div class="level-left">
                            <div class="level-item">
                                <p class="title">
                                    <span *ngIf="!cargando" class="icon is-medium">
                                        <i class="icon-file"></i>
                                    </span>
                                    Facturación {{facturacion.Version}}
                                </p>
                            </div>

                        </div>
                        <div class="level-right">

                            <a class=" navbar-item tooltip" (click)="buscar_venta()">
                                <span class="icon fa-2x">
                                    <i class="icon-search3"></i>
                                </span>
                                <span class="is-hidden-touch">&nbsp; Buscar</span>
                            </a>

                            <a class=" navbar-item tooltip" (click)="ctrl.abrirModal('ventas_colas')">
                                <span class="icon fa-2x">
                                    <i class="fa fa-calendar"></i>
                                </span>
                                <span class="is-hidden-touch">&nbsp; Mes actual</span>
                            </a>

                            <a class=" navbar-item tooltip" id="imprimir_pdf" (click)="ctrl.imprimeFactura(facturacion, logo, personas_rfcs_seleccionado)">
                                <span class="icon fa-2x">
                                    <i class="icon-printer2"></i>
                                </span>
                                <span class="tooltiptext is-hidden-touch">&nbsp; Imprimir</span>
                            </a>

                            <button class="navbar-item is-success tooltip" (click)="ctrl.abrirModal('confirmarTimbrar')" [disabled]="cargando" *ngIf="valido">
                                <span class="icon fa-2x has-text-black">
                                    <i class="fa fa-qrcode"></i>
                                </span>
                                <span class="tooltiptext is-hidden-touch">&nbsp; Timbrar</span>
                            </button>
                        </div>
                    </nav>
                    <div class="container is-fluid">
                        <div class="columns">
                            <div class="column is-6">
                                Cliente:
                                <input autofocus autocomplete="off" [(ngModel)]="cliente" ngui-auto-complete [source]="observableSource.bind(this)" [list-formatter]="autocompleListFormatter" [close-on-focusout]="false"
                                    id='rfc' value-property-name="rfc" display-property-name="nombre" path-to-data="" loading-text="Cargando..."
                                    no-match-found-text="No hay resultados." (valueChanged)="select_cliente_autocomplete($event)"
                                    min-chars="1" class="input is-expanded" type="text" placeholder="RFC del cliente">

                            </div>
                            <div class="column is-3">
                                Venta:
                                <input class="input is-expanded" type="text" placeholder="Código de la venta" [(ngModel)]="codigo">
                            </div>

                            <div class="column is-3">
                                Condición de pago:
                                <input class="input" type="text" placeholder="Condiciones de pago" [(ngModel)]="facturacion.CondicionesDePago" [ngModelOptions]="{standalone: true}">
                            </div>
                        </div>

                        <div class="columns">
                            <div class="column is-9">
                                Uso CFDI:
                                <div class="select" style="float:right">
                                    <select class="select" [(ngModel)]="facturacion.Receptor.UsoCFDI" [ngModelOptions]="{standalone: true}">
                                        <option *ngFor="let item of ctrl.catalogos_usos_cfdis" value="{{item.clave}}">{{item.nombre}}</option>
                                    </select>
                                </div>   
                            </div>

                            <div class="column is-3">
                                <!-- Checkbox -->
                            <!--
                                <div class="field">
                                    <label class="checkbox">
                                        <input type="checkbox" [(ngModel)]="esFacturaGlobal" name="esFacturaGlobal">
                                        Es Factura Global
                                    </label>
                                </div> 
                            --> 
                            </div>
                        </div>

                        <div class="columns">
                            <div class="column is-12">
                                
                                <div *ngIf="esFacturaGlobal" class="columns">

                                    <div class="column is-4">
                                        <!-- Select Periodicidad -->
                                        <div class="field">
                                            <label >Periodicidad de Factura Global</label>
                                            <div class="control">
                                            <div class="select">
                                                <select [(ngModel)]="periodicidad_global" name="periodicidad_global">
                                                <option value="">Seleccione</option>
                                                <option value="01">Diaria</option>
                                                <option value="02">Semanal</option>
                                                <option value="03">Mensual</option>
                                                </select>
                                            </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="column is-4">
                                        <!-- Select Mes -->
                                        <div class="field">
                                            <label  >Mes de Factura Global</label>
                                            <div class="control">
                                            <div class="select">
                                                <select [(ngModel)]="mes_global" name="mes_global">
                                                <option value="">Seleccione</option>
                                                <option *ngFor="let mes of meses" [value]="mes.value">{{ mes.label }}</option>
                                                </select>
                                            </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="column is-4">
                                        <!-- Select Año -->
                                        <div class="field">
                                            <label  >Año de Factura Global</label>
                                            <div class="control">
                                            <div class="select">
                                                <select [(ngModel)]="anio_global" name="anio_global">
                                                <option value="">Seleccione</option>
                                                <option *ngFor="let anio of anios" [value]="anio">{{ anio }}</option>
                                                </select>
                                            </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>




                    </div>
                </div>
            </section>
            <div class="notification is-danger" *ngIf="error_timbre">
                ¡Ocurrio un error al intentar timbrar la factura!
                <strong>Por favor</strong>, intentelo de nuevo
            </div>
            <div class="notification is-danger" *ngIf="error_busqueda">
                ¡Ocurrio un error al intentar buscar!
                <strong>Por favor</strong>, intentelo de nuevo
            </div>
            <div class="notification is-black" *ngIf="sin_resultado != ''">
                ¡Mesaje del servidor!
                <strong>{{sin_resultado}}</strong>
            </div>
            <div *ngIf="errores.length > 0">
                <div class="notification is-danger" *ngFor="let msg of errores;">
                    <font size="6pt">{{msg.codigo}}</font> {{msg.mensaje}}
                    <strong>{{msg.fecha | formatoFecha}}</strong>
                </div>
            </div>
            <div class="is-fullwidth has-text-centered" *ngIf="cargando">
                <br>
                <span class="tag is-primary is-large ">
                    <span class="icon">
                        <i class="icon-worldwide fa-spin"></i>
                    </span> &nbsp;
                    <span>Cargando...</span>
                </span>
                <br>
                <br>
            </div>
            <br>
            <div id="imprimir">
                <article class="media">
                    <div class="media-content">
                        <div>
                            <!-- emisor -->
                            <div class="columns">
                                <div class="column is-2">
                                    <figure class="image is-1by1 figure-border logo">
                                        <img [src]="ctrl.configuracion.sucursal.logo ? ctrl.API_PATH+'/adjunto/configuracion/'+ ctrl.configuracion.sucursal.logo : ctrl.configuracion.empresa.logo ? ctrl.API_PATH+'/adjunto/configuracion/'+ ctrl.configuracion.empresa.logo : './assets/yoursoft.png'">
                                    </figure>
                                </div>

                                <div class="column is-6">
                                    <div class="box">
                                        <article class="media">
                                            <div class="media-content">
                                                <div class="content">
                                                    <p>
                                                        <strong>Folio fiscal: </strong>
                                                        {{facturacion.Complemento.TimbreFiscalDigital.UUID}}
                                                    </p>
                                                    <p>
                                                        <strong>No. de serie del CSD: </strong>
                                                        {{facturacion.NoCertificado}}
                                                    </p>
                                                    <p>
                                                        <strong>No. de serie del certificado SAT: </strong>
                                                        {{facturacion.Complemento.TimbreFiscalDigital.NoCertificadoSAT}}
                                                    </p>
                                                    <p>
                                                        <strong>Fecha y hora de emisión: </strong>
                                                        {{facturacion.Fecha }}
                                                    </p>
                                                    <p>
                                                        <strong>Fecha y hora de certificación: </strong>
                                                        {{facturacion.Complemento.TimbreFiscalDigital.FechaTimbrado}}
                                                    </p>
                                                </div>
                                            </div>
                                        </article>
                                    </div>
                                </div>

                                <div class="column is-4">
                                    <div class="box">
                                        <article class="media">
                                            <div class="media-content">
                                                <div class="content">
                                                    <p>
                                                        <strong>Emisor: </strong>
                                                        {{facturacion.Emisor.Nombre}}
                                                    </p>
                                                    <p>
                                                        <strong>R.F.C.: </strong>
                                                        {{facturacion.Emisor.Rfc}}
                                                    </p>
                                                    <p>
                                                        <strong>Lugar de expedición: </strong>
                                                        {{facturacion.LugarExpedicion}}
                                                    </p>
                                                    <p>
                                                        <strong>Régimen fiscal: </strong>
                                                        {{facturacion.Emisor.RegimenFiscal}}
                                                    </p>
                                                    <p>
                                                        <strong>Tipo de comprobante: </strong>
                                                        {{facturacion.TipoDeComprobante}}
                                                    </p>

                                                </div>
                                            </div>
                                        </article>
                                    </div>
                                </div>
                            </div>
                            <!-- datos del cliente -->
                            <div class="columns">
                                <div class="column is-8">
                                    <div class="box">
                                        <article class="media">
                                            <div class="media-content">
                                                <div class="content">
                                                    <p>
                                                        <strong>Receptor:</strong>
                                                        {{facturacion.Receptor.Nombre}}
                                                    </p>
                                                    <p>
                                                        <strong>R.F.C.:</strong>
                                                        {{facturacion.Receptor.Rfc}}
                                                    </p>
                                                </div>
                                            </div>
                                        </article>
                                    </div>
                                </div>
                                <div class="column is-4">
                                    <div class="box">
                                        <article class="media">
                                            <div class="media-content">
                                                <div class="content">
                                                    <p>
                                                        <strong>Uso CFDI:</strong>
                                                        {{facturacion.Receptor.UsoCFDI}}
                                                    </p>
                                                    <p>
                                                        <strong>Folio y serie:</strong>
                                                        {{facturacion.Folio}} {{facturacion.Serie}}
                                                    </p>
                                                </div>
                                            </div>
                                        </article>
                                    </div>
                                </div>
                            </div>
                            <!-- complemento educativo -->
                            <div class="columns" *ngIf="facturacion.Conceptos.Concepto.length > 0 ">
                              <div class="column is-12">
                                <div class="box">
                                  <article class="media">
                                    <div class="media-content">
                                      <div class="content">

                                        <table class="table is-striped  is-fullwidth">
                                          <thead>
                                            <tr>
                                              <th>IEDU Versión</th>
                                              <th>Alumno </th>
                                              <th>CURP </th>
                                              <th>Nivel</th>
                                              <th>RVOE </th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr>
                                              <td>{{facturacion.Conceptos.Concepto[0].ComplementoConcepto.version}}</td>
                                              <td>{{facturacion.Conceptos.Concepto[0].ComplementoConcepto.nombreAlumno}}</td>
                                              <td>{{facturacion.Conceptos.Concepto[0].ComplementoConcepto.CURP}}</td>
                                              <td>{{facturacion.Conceptos.Concepto[0].ComplementoConcepto.nivelEducativo}}</td>
                                              <td>{{facturacion.Conceptos.Concepto[0].ComplementoConcepto.autRVOE}}</td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </article>
                                </div>
                              </div>
                            </div>

                            <!-- detalle de los articulos -->
                            <div class="columns">
                                <div class="column is-12">
                                    <div class="box">
                                        <article class="media">
                                            <div class="media-content">
                                                <div class="content">
                                                    <table class="table is-striped  is-fullwidth">
                                                        <thead>
                                                            <tr>
                                                                <th>Cve prod/serv </th>
                                                                <th>No. Identificacion </th>
                                                                <th>Cantidad </th>
                                                                <th>Unidad</th>
                                                                <th>Descripción </th>
                                                                <th>Precio </th>
                                                                <th>Descuento </th>
                                                                <th>Impuesto </th>
                                                                <th>Importe </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr *ngFor="let concepto of facturacion.Conceptos.Concepto; let i = index">
                                                                <td>{{concepto.ClaveProdServ}}</td>
                                                                <td>{{concepto.NoIdentificacion}}</td>
                                                                <td>{{concepto.Cantidad}}</td>
                                                                <td>{{concepto.ClaveUnidad}} {{concepto.Unidad}}</td>
                                                                <td>{{concepto.Descripcion}}</td>  
                                                                <td>{{concepto.ValorUnitario | currency:ctrl.configuracion.sucursal.moneda}} </td>
                                                                <td>{{concepto.Descuento | currency:ctrl.configuracion.sucursal.moneda}}</td>
                                                                <td>
                                                                    <span *ngIf="concepto.Impuestos">
                                                                        <small *ngIf="concepto.Impuestos.Traslados">Traslados</small>
                                                                        <span *ngFor="let traslado of concepto.Impuestos.Traslados">
                                                                            <strong>{{traslado.Traslado.Impuesto}} ({{traslado.Traslado.TipoFactor
                                                                                == 'Tasa' || traslado.Traslado.TipoFactor
                                                                                == '1' ? (traslado.Traslado.TasaOCuota
                                                                                * 100) + '%' : (traslado.Traslado.TipoFactor == '3' ? 'Excento' : traslado.Traslado.TipoFactor)}}):
                                                                            </strong>
                                                                            {{ traslado.Traslado.TipoFactor == 'Tasa' || traslado.Traslado.TipoFactor
                                                                            == '1' ? (traslado.Traslado.Importe  | currency:ctrl.configuracion.sucursal.moneda) : ''}}
                                                                        </span>
                                                                    </span>

                                                                    <span *ngIf="concepto.Impuestos">
                                                                        <small *ngIf="concepto.Impuestos.Retenciones">Retenciones</small>
                                                                        <span *ngFor="let retencion of concepto.Impuestos.Retenciones">
                                                                            <strong>{{retencion.Retencion.Impuesto}} ({{retencion.Retencion.TipoFactor
                                                                                == 'Tasa' || retencion.Retencion.TipoFactor
                                                                                == '1' ? (retencion.Retencion.TasaOCuota
                                                                                * 100) + '%' : (retencion.Retencion.TipoFactor == '3' ? 'Excento' : retencion.Retencion.TipoFactor )}}):</strong>
                                                                            {{ traslado.Retencion.TipoFactor == 'Tasa' || traslado.Retencion.TipoFactor
                                                                            == '1' ? (retencion.Retencion.Importe | currency:ctrl.configuracion.sucursal.moneda) : ''}}
                                                                        </span>
                                                                    </span>
                                                                </td>
                                                                <td>{{concepto.Importe | currency:ctrl.configuracion.sucursal.moneda}}</td>
                                                               
                                                            </tr>
                                                        </tbody>

                                                    </table>
                                                </div>
                                            </div>
                                        </article>
                                    </div>
                                </div>
                            </div>
                            <!-- pago -->
                            <div class="columns">
                                <div class="column is-8">
                                    <div class="box">
                                        <article class="media">
                                            <div class="media-content">
                                                <div class="content">
                                                    <div>
                                                        <strong>Total con letra</strong>
                                                        {{facturacion.Total | numeroLetra:configuracion.sucursal.moneda}}
                                                        <hr class="hr">
                                                    </div>
                                                    <div class="columns">
                                                        <div class="column is-6">
                                                            <p>
                                                                <strong>Moneda:</strong>
                                                                {{facturacion.Moneda}}
                                                            </p>
                                                            <p>
                                                                <strong>Forma de pago:</strong>
                                                                {{facturacion.FormaPago}}
                                                            </p>
                                                        </div>
                                                        <div class="column is-6">
                                                            <p>
                                                                <strong>Método de pago:</strong>
                                                                {{facturacion.MetodoPago}}
                                                            </p>
                                                            <p>
                                                                <strong>Condiciones de pago:</strong>
                                                                <span class="sellos_sat" style="word-wrap: break-word; font-size:9pt;">
                                                                    {{facturacion.CondicionesDePago}}
                                                                </span>
                                                            </p>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </article>
                                    </div>
                                </div>
                                <div class="column is-4">
                                    <div class="box">
                                        <article class="media">
                                            <div class="media-content">
                                                <div class="content">
                                                    <p>
                                                        <strong>Subtotal:</strong>
                                                        {{facturacion.SubTotal | currency:ctrl.configuracion.sucursal.moneda}}
                                                    </p>
                                                    <p>
                                                        <strong>Descuento:</strong>
                                                        {{facturacion.Descuento | currency:ctrl.configuracion.sucursal.moneda}}
                                                    </p>
                                                    <div class="impuestos_fac" *ngIf="facturacion.Impuestos">

                                                        <small *ngIf="facturacion.Impuestos.Traslados.length > 0">Traslados</small>
                                                        <p *ngFor="let traslado of facturacion.Impuestos.Traslados">
                                                            <strong>{{traslado.Traslado.Impuesto}} ({{traslado.Traslado.TipoFactor
                                                                == 'Tasa' || traslado.Traslado.TipoFactor
                                                                == '1' ? (traslado.Traslado.TasaOCuota
                                                                * 100) + '%' : (traslado.Traslado.TipoFactor == '3' ? 'Excento' : traslado.Traslado.TipoFactor)}}):
                                                            </strong>
                                                            {{ traslado.Traslado.TipoFactor == 'Tasa' || traslado.Traslado.TipoFactor
                                                            == '1' ? (traslado.Traslado.Importe  | currency:ctrl.configuracion.sucursal.moneda) : ''}}

                                                        </p>
                                                    </div>
                                                    <div class="impuestos_fac" *ngIf="facturacion.Impuestos">
                                                        <small *ngIf="facturacion.Impuestos.Retenciones.length > 0">Retenciones</small>
                                                        <p *ngFor="let retencion of facturacion.Impuestos.Retenciones">
                                                            <strong>{{retencion.Retencion.Impuesto}} ({{retencion.Retencion.TipoFactor
                                                                == 'Tasa' || retencion.Retencion.TipoFactor
                                                                == '1' ? (retencion.Retencion.TasaOCuota
                                                                * 100) + '%' : (retencion.Retencion.TipoFactor == '3' ? 'Excento' : retencion.Retencion.TipoFactor )}}):</strong>
                                                            {{ traslado.Retencion.TipoFactor == 'Tasa' || traslado.Retencion.TipoFactor
                                                            == '1' ? (retencion.Retencion.Importe | currency:ctrl.configuracion.sucursal.moneda) : ''}}

                                                        </p>
                                                    </div>
                                                    <p>
                                                        <strong>Total:</strong>
                                                        {{facturacion.Total | currency:ctrl.configuracion.sucursal.moneda}}
                                                    </p>
                                                </div>
                                            </div>
                                        </article>
                                    </div>
                                </div>
                            </div>

                            <!-- qy y sellos -->
                            <div class="columns">
                                <div class="column is-2">
                                    <figure class="image is-1by1 figure-border">
                                        <img [src]="'data:image/png;base64,' + facturacion.Complemento.TimbreFiscalDigital.qr" *ngIf="facturacion.Complemento.TimbreFiscalDigital.qr != ''">
                                        <img src="assets/qr.png" *ngIf="facturacion.Complemento.TimbreFiscalDigital.qr == ''">
                                    </figure>
                                </div>
                                <div class="column is-10">
                                    <div class="box">
                                        <article class="media">
                                            <div class="media-content">
                                                <div class="content sellos">
                                                    <div>
                                                        <strong>Sello digital del CFDI:</strong>
                                                        <br>
                                                        <div class="sellos_sat" style="word-wrap: break-word; font-size:8.5pt;">
                                                            {{facturacion.Complemento.TimbreFiscalDigital.SelloCFD}}
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <strong>Sello digital del SAT:</strong>
                                                        <br>
                                                        <div class="sellos_sat" style="word-wrap: break-word; font-size:8.5pt;">
                                                            {{facturacion.Complemento.TimbreFiscalDigital.SelloSAT}}
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <strong>Cadena original del complemento de certificación del SAT:
                                                        </strong>
                                                        <br>
                                                        <div class="sellos_sat" style="word-wrap: break-word; font-size:8.5pt;">
                                                            {{facturacion.Complemento.TimbreFiscalDigital.CadenaOriginal}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </article>
                                    </div>
                                </div>
                            </div>
                            <p align="center">
                                <strong>Este documento es una representación impresa de un CFDI versión {{VERSION_CFDI}}</strong>
                            </p>
                        </div>
                    </div>
                </article>
            </div>
        </div>
    </div>
</div>


<div class="modal" id="ventas_colas">
    <div class="modal-background"></div>
    <div class="modal-card" style="width:75%">
        <header class="modal-card-head">
            <h1>Lista de ventas disponibles para facturar</h1>
        </header>
        <section class="modal-card-body">
            <div class="content">
                <div class="field has-addons">
                    <div class="control has-icons-left is-expanded">
                        <input type="text" class="input is-flat is-medium" placeholder="Buscar" [(ngModel)]="busqueda" id="search-box">
                        <span class="icon is-medium is-left">
                            <i class="icon-search3"></i>
                        </span>
                    </div>
                    <p class="control">
                        <button class="button is-medium is-primary" [ngClass]="{ 'is-disabled': busqueda==''}" (click)="busqueda=''">
                            <span class="icon">
                                <i class="fa fa-close"></i>
                            </span>
                        </button>
                    </p>
                </div>

                <div class="field has-addons">

                    <div class="control">

                        <div class="select">
                            <select class="select" [(ngModel)]="tipo">
                                <option value="">Ambos</option>
                                <option value="Efectivo">Efectivo</option>
                                <option value="Tarjeta">Tarjeta</option>
                            </select>
                        </div>

                    </div>
                    <div class="control">
                        <div class="field">
                            <input class="input" [value]="fecha_desde" [(ngModel)]='desde' [ngModelOptions]="{standalone: true}" type="date"
                                placeholder="Fecha desde"  />
                        </div>
                    </div>
                    <!-- <div class="control">
                        <div class="field">
                            <input class="input" [value]="fecha_actual" [(ngModel)]='hasta' [ngModelOptions]="{standalone: true}" type="date"
                                placeholder="Fecha hasta"  />
                        </div>
                    </div> -->

                    <div class="control">
                        <div class="field">
                            <div class="b-checkbox input">
                                <input id="requiere_factura" class="styled" type="checkbox" [(ngModel)]="requiere_factura" >
                                <label for="requiere_factura">
                                    Requiere factura
                                </label>
                            </div>
                        </div>
                    </div>

                    <p class="control">
                        <button class="button is-primary" (click)="ventas_mes()">
                            Buscar
                        </button>
                    </p>
                </div>
                <div class="is-fullwidth has-text-centered" *ngIf="cargando">
                    <br>
                    <span class="tag is-primary is-large ">
                        <span class="icon">
                            <i class="icon-worldwide fa-spin"></i>
                        </span> &nbsp;
                        <span>Cargando...</span>
                    </span>
                    <br>
                    <br>
                </div>
                <div style="overflow:auto; display:block" [style.height.px]="ctrl.tamano-375">
                    <table class="table is-striped  is-fullwidth">
                        <thead>
                            <tr>
                                <th>
                                    <div class="field">
                                        <div class="b-checkbox is-info">
                                            <input id="todo_mes" class="styled" type="checkbox" (click)="agregar_venta_mes()" [(ngModel)]="todas_ventas" [checked]="todas_ventas">
                                            <label for="todo_mes">
                                                Todos
                                            </label>
                                        </div>
                                    </div>
                                </th>
                                <th>Código </th>
                                <th>Fecha</th>
                                <th>Forma Pago</th>
                                <th>Cliente </th>
                                <th>Importe</th>
                                <th>Capturo</th>
                                <th>Comentario</th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of facturas_mes | buscar: busqueda; let i=index">
                                <td>
                                    <div class="field">
                                        <div class="b-checkbox is-info">
                                            <input id="venta{{i}}" class="styled" type="checkbox" (click)="agregar_venta(item)" [checked]="ventas_mes_facturar.indexOf(item.id) > -1">
                                            <label for="venta{{i}}">

                                            </label>
                                        </div>
                                    </div>
                                </td>
                                <td style="vertical-align: middle;">
                                    <label for="venta{{i}}">{{item.codigo}}</label>
                                </td>
                                <td style="vertical-align: middle;">{{ item.created_at | formatoFecha}} </td>
                                <td style="vertical-align: middle;">{{ item.forma_pago}} </td>
                                <th style="vertical-align: middle;">
                                    <span *ngIf="item.personas">{{item.personas.nombre}}</span>
                                </th>
                                <td style="vertical-align: middle;">
                                    {{item.total | currency:ctrl.configuracion.sucursal.moneda}}
                                </td>
                                <td style="vertical-align: middle;">{{ item.usuarios.nombre }} </td>
                                <td style="vertical-align: middle;">{{ item.comentarios }} </td>

                            </tr>
                            <tr *ngIf="ctrl.dato.length == 0">
                                <td colspan="7" style="vertical-align: middle; color:#888;">Esta lista está vacía.</td>
                            </tr>
                        </tbody>

                    </table>
                </div>
            </div>
        </section>
        <footer class="modal-card-foot">
            <button class="button is-success" (click)="agregar_facturacion()" [disabled]="ventas_mes_facturar.length == 0">Agregar a facturación</button>
            <a class="button" (click)="ctrl.cancelarModal('ventas_colas')" id="close_ventas_colas">Cancelar</a>
        </footer>
    </div>
</div>

<div class="modal" id="confirmarTimbrar">
    <div class="modal-background"></div>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">
                <i class="fa fa-warning"></i> Confirmar</p>
            <button class="delete" (click)="ctrl.cancelarModal('confirmarTimbrar')"></button>
        </header>
        <section class="modal-card-body">
            <div class="content">
                <h1>¿Esta seguro de iniciar el proceso de timbrado?</h1>
                <p>Ya no se podra agregar más información a esta hoja</p>
            </div>
        </section>
        <footer class="modal-card-foot">
            <a class="button is-success" (click)="timbrar()">Continuar</a>
            <a class="button" (click)="ctrl.cancelarModal('confirmarTimbrar')">Cancelar</a>
        </footer>
    </div>
</div>
